import Slider from "react-slick";
import { ApiEndpoints } from "../helper/ApiEndpoints";
import { BaseUrl } from "../helper/BaseUrl";
import ApiRequest from "../helper/ApiRequest";
import { useEffect, useState } from "react";

const ListEndpoint = ApiEndpoints.clientLogo.List;

const settings2 = {
  dots: false,
  arrows: false,
  slidesToShow: 5,
  infinite: true,
  autoplay: true,
  slidesToScroll: 1,
  pauseOnHover: false,
  cssEase: "linear",
  autoplaySpeed: 0,
  speed: 5000,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
      },
    },

    {
      breakpoint: 767,
      settings: {
        slidesToShow: 4,
      },
    },

    {
      breakpoint: 599,
      settings: {
        slidesToShow: 3,
      },
    },],
};

export default function HomeTeamlogo() {

  const [data, setData] = useState([]);

  useEffect(() => {
    const dataFetch = async () => {
      try {
        const response = await ApiRequest("GET", ListEndpoint);
        const result = response.logos;
        setData(result);
      } catch (error) {
        console.log(error);
      }
    };
    dataFetch();
  }, []);

  const half = Math.ceil(data.length / 2);
  const firstHalf = data.slice(0, half);
  const secondHalf = data.slice(half);

  return (
    <>
      <section className="home-teamlogo">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2 className="heading center-heading">
                Collaborating with Top Brands Throughout the Years
              </h2>
              <Slider className="teamlogo-slider" {...settings2}>
                {firstHalf.map((logo, index) => (
                  <div key={index} className="teamlogo-box">
                    <div>
                      <small><img width="175" height="102" src={BaseUrl + logo.logo} alt={ logo?.alt_logo || `team logo ${index + 1}`}
                        loading="lazy"
                      /></small>
                      <span>{logo.country}</span>
                    </div>
                  </div>
                ))}
              </Slider>
              <Slider className="teamlogo-slider team-log-slide-reverse" {...{ ...settings2, rtl: true }}>
                {secondHalf.map((logo, index) => (
                  <div key={index} className="teamlogo-box">
                    <div>
                      <small><img width="175" height="102" src={BaseUrl + logo.logo} alt={ logo?.alt_logo || `team logo ${index + 1}`}
                      loading="lazy"/></small>
                      <span>{logo.country}</span>
                    </div>
                  </div>
                ))}
              </Slider>
              {/* <Slider className="teamlogo-slider" {...settings2}>
                {data.map((logo, index) => (
                  <div key={index} className="teamlogo-box">
                    <div>
                      <small><img width="175" height="102" src={BaseUrl + logo.logo} alt={ logo?.alt_logo || `team logo ${index + 1}`}
                      loading="lazy"/></small>
                      <span>{logo.country}</span>
                    </div>
                  </div>
                ))}
              </Slider> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
